import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import { activeBranch } from "./setting";

// Loan types can be switched off per branch, so a sidebar has to be built for
// the branch the user is working in. Only sidebar requests need it: the Role
// Permission screen must keep listing every menu.
const sidebarQuery = (forSidebar) => {
  if (!forSidebar) return "";
  const branch = activeBranch();
  return branch === "" ? "?sidebar=1" : `?sidebar=1&branch_id=${encodeURIComponent(branch)}`;
};

const authHeader = (ct = "application/json") => ({
  Authorization: "Bearer " + localStorage.getItem("token"),
  "Content-Type": ct,
});

function catcherror(error) {
  if (error?.response?.status === 401) {
    localStorage.clear();
    window.location.href = "/";
  } else {
    toast.error(error?.response?.data?.message || error?.message || "Something went wrong");
  }
}

// All menus (for the Role Permission management screen)
export async function menuList() {
  try {
    return await axios
      .get(`${baseUrl}/menulist`, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

// Menus a role can access. Pass forSidebar=true when rendering a sidebar so
// features disabled in Settings are hidden too; leave it off for the Role
// Permission screen, which must still show every assigned menu.
export async function roleMenuList(roleId, forSidebar = false) {
  try {
    return await axios
      .get(`${baseUrl}/rolemenulist/${roleId}${sidebarQuery(forSidebar)}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

// Assign menus to a role
export async function updateRoleMenuList(roleId, selectedIds) {
  try {
    const menu_ids = Array.isArray(selectedIds) ? selectedIds.join(",") : selectedIds;
    return await axios
      .post(`${baseUrl}/update-role-menu-list`, { role_id: roleId, menu_ids }, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

// Menus a single user can access (user-level override of their role).
// Returns empty Items when the user has no override saved.
export async function userMenuList(userId, forSidebar = false) {
  try {
    return await axios
      .get(`${baseUrl}/usermenulist/${userId}${sidebarQuery(forSidebar)}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

// Assign menus to a single user (overrides their role)
export async function updateUserMenuList(userId, selectedIds) {
  try {
    const menu_ids = Array.isArray(selectedIds) ? selectedIds.join(",") : selectedIds;
    return await axios
      .post(`${baseUrl}/update-user-menu-list`, { user_id: userId, menu_ids }, { headers: authHeader() })
      .then((res) => res.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}
